export default {
  common: {
    casino: "Casino",
    more: "More",
    searchGames: "Search games",
    copied: "Copied!",
    inputTooLong: "Input is too long, please re-enter.",
    inputNameCn: "Only Chinese, English letters, numbers and underscore are allowed",
    inputCapital: "Only uppercase letters and underscore are allowed",
    inputLowercaseUnderscore: "Only lowercase letters and underscore are allowed",
    inputLowercase: "Only lowercase letters are allowed",
    inputNoSpace: "Please do not enter only spaces",
    inputValidPhone: "Please enter a valid phone number",
    inputNonNumber: "Contains non-numeric characters",
    inputNonLetter: "Contains non-letter characters",
    inputLetterOrNumberOnly: "Only letters or numbers are allowed",
    phoneFormatError: "Invalid phone number format",
    inputLetterStartNumber: "Must start with a letter and may contain numbers",
    inputNoChinese: "Chinese characters are not allowed",
    inputChineseOnly: "Only Chinese characters are allowed",
    emailFormatError: "Invalid email format",
    urlFormatError: "Invalid URL format",
    jsonFormatError: "Invalid JSON format",
    networkError: "Failed to reach the server, please try again later.",
    siteUnavailable: "This site is currently unavailable, please contact the administrator.",
    tokenExpired: "Your session has expired, please sign in again.",
    domainNotAuthorized: "Domain not authorized",
    demoEnvOnly: "Demo environment, for preview only",
    passwordLength630: "6-30 characters",
    newPasswordSameAsOld: "New password cannot be the same as old password",
    confirmNewPassword: "Please confirm your new password",
    passwordsDoNotMatch: "Passwords do not match",
    withdrawPasswordChanged: "Withdraw password changed successfully",
    withdrawPasswordSet: "Withdraw password set successfully",
    withdrawPasswordSetFailed: "Failed to set withdraw password",
    phoneDigitsOnly: "Phone number must be digits only",
    phoneTooShort: "Phone number is too short (min {min} digits)",
    phoneTooLong: "Phone number is too long (max {max} digits)",
    phoneInvalidPrefix: "Invalid phone number prefix",
    rolloverAll: "All Types",
    rolloverAllStats: "All Stats",
    rolloverSuccessful: "Successful",
    rolloverFailed: "Failed",
    rolloverInProgress: "In Progress",
    rolloverSuccess: "Success",
    rolloverPending: "Pending",
    rolloverCompleted: "Completed",
    rolloverCancelled: "Cancelled",
    rolloverExpired: "Expired",
    walletCash: "Cash",
    walletBonus: "Bonus",
    sourceDeposit: "Deposit",
    sourceCommission: "Commission",
    sourceManualAdd: "Manual Add",
    sourceManualSubtract: "Manual Subtract",
  },
  redeemCode: {
    title: "Redeem Code",
    enterTip: "Enter your redeem code to claim rewards",
    placeholder: "Please Enter Your Code",
    redeemBtn: "REDEEM",
    submitting: "REDEEMING...",
    pleaseEnterCode: "Please enter your redeem code",
    redeemSuccess: "Redeem successful!",
    redeemFailed: "Redeem failed, please try again",
  },
};
